// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { App } from './app'
import router from './router'
import store from './store'
import jQuery from 'jquery'
import AWS from 'aws-sdk'
import VueSwal from 'vue-swal'
import VueFire from 'vuefire'
import Notifications from 'vue-notification'
import gallery from 'img-vuer'
import Spinner from 'vue-simple-spinner'
import vSelect from 'vue-select'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
import { getItem, clear } from './storage'
import i18n from './i18n';

// const Sqlite = require('nativescript-sqlite')

window.jQuery = jQuery
window.$ = jQuery

Vue.use(BootstrapVue)
Vue.use(VueSwal)
Vue.use(VueFire)
Vue.use(Notifications)
Vue.use(gallery)
Vue.use(Donut)
Vue.use(AWS)
Vue.component('spinner', Spinner)
Vue.component('v-select', vSelect)
Vue.mixin({
  methods: {
		//translate with fallback
    $tf(key, fallback = null) {
      const translation = this.$t(key)
      return translation === key ? fallback : translation
    }
  }
})

function checkSession () {
	return getItem('token').then(token => {
		if (token) {
			return getItem('loginTime').then(time => {
				if (time) {
		    	let loginTime = new Date(time)
		      let currentTime = (new Date()).getTime()
		      let currentSessionDuration = (currentTime - loginTime) / 60000
		      return (currentSessionDuration > 480) // session will expire in 480 mins (8 hrs)
		    }
		    return true
			})
		}
		return true
	})
}

router.beforeEach((to, from, next) => {
	checkSession().then(isSessionExpired => {
		if (to.name !== 'login' && to.name !== 'redirectToWeb' && to.name !== 'redirectToWebWidgetVerification' && to.name !== 'redirectToWebVerification'  && isSessionExpired) {
      clear()
	    next({name: 'login'})
	  } else {
	    next()
	  }
	})
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
	i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js